import React, { FC, PropsWithChildren } from "react"
import { Divider, DividerProps, Text } from "@mantine/core"

type PageDividerProps = DividerProps

const PageDivider: FC<PropsWithChildren<PageDividerProps>> = ({ children, ...props }) => (
    <Divider
        label={
            <Text size="md" color="dimmed" weight="bold" sx={theme => ({ fontFamily: theme.headings.fontFamily })}>
                {children}
            </Text>
        }
        {...props}
    />
)

export default PageDivider
